import { IPublicationPackagesState } from '../../../reducers/v2';
import type { IServicePackagePeriod } from '../../../repositories/billing-tariffs/entities/PublishTerms/ServicePackagePeriod';
import { getPackageId } from './getPackageId';
import { getServiceId, mapInternalServiceTypes } from '../../../utils/publishTerms';
import { EServiceType } from '../../../types/reducers/publishTerms';

export const mapPublicationPackages = (servicePackages: IServicePackagePeriod[]): IPublicationPackagesState => {
  return {
    packagesList: servicePackages.map(service => {
      const id = getPackageId(service);
      const services = mapInternalServiceTypes<EServiceType>(service.tariffIdentificator.serviceTypes);
      const serviceId = getServiceId(services);

      return {
        days: service.days,
        id,
        label: service.label,
        marketingPrice: service.marketingPrice,
        offersCount: service.servicePackageActualCount,
        price: service.price,
        selected: service.isDefault,
        token: service.token || '',
        serviceId,
        endDate: service.servicePackageEndDate,
      };
    }),
  };
};
